import React, { useEffect, useRef, useState } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CRow,
  CLoadingButton,
  CFormSelect,
  CFormLabel,
  CMultiSelect,
  CFormTextarea,
  CButton,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CInputGroup,
  CInputGroupText,
  CHeaderNav,
  CButtonGroup,
  CTooltip,
  CLink,
} from '@coreui/react-pro'
import Bootbox from 'bootbox-react'
import moment from 'moment'
import { cilInfo, cilList, cilReload, cilSave } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import ToastComponent from 'src/components/common/TaostComponent'
import ScorecardService from 'src/service/ScorecardService'
import CompleteMarkModal from './CompleteMarkModal'
import { Link, useParams, useNavigate } from 'react-router-dom'
import Loader from 'src/components/Loader'
import MarkAsCompleteModal from './MarkAsCompleteModal'
import { useFormik } from 'formik'

const CommonScorecard = (props) => {
  const formRef = useRef(null)
  const navigate = useNavigate()
  const [commonScorecardLoading, setCommonScorecardLoading] = useState(false)
  const [finalScorecardModalVisible, setFinalScorecardModalVisible] = useState(false)
  const [statusValue, setStatusValue] = useState(props?.statusValue ?? 0)
  const [defaultInning, setDefaultInning] = useState(1)
  const [completMarkModalVisible, setCompletMarkModalVisible] = useState(false)
  const [visible, setVisible] = useState(false)
  const formikRef = React.useRef()
  const formik = useFormik({
    initialValues: {
      data: props.scorecardDetails,
      scorcard_link_name: props.fixtureDetails?.scorcard_link_name,
      scorcard_link_url: props.fixtureDetails?.scorcard_link_url,
      fall_of_wickets: props.fixtureDetails?.fall_of_wickets,
      match_report: props.fixtureDetails?.match_report,
      potm_match_status: props.fixtureDetails?.potm_match_status,
      match_status: '',
    },
    enableReinitialize: true,
    onSubmit: (data, actions) => {
      setCommonScorecardLoading(true)
      data.fixtureId = props.fixtureId
      data.potm = props.selectedValue
      data.status = statusValue
      data.inning = defaultInning
      props.setLoader(true)
      ScorecardService.saveScorecard(data).then((res) => {
        if (res.status === 200) {
          setCommonScorecardLoading(false)
          props.fetchData(defaultInning)
          ToastComponent(res.message, 'success')
        }
      })
    },
  })
  useEffect(() => {
    formikRef.current = formik
  }, [formik])
  const [showResetConfirm, setShowResetConfirm] = useState(false)
  const handleResetConfirm = () => {
    resetFixtureScorecard()
    return setShowResetConfirm(false)
  }
  const handleResetCancel = () => {
    return setShowResetConfirm(false)
  }
  const clearScorecard = () => {
    setShowResetConfirm(true)
    console.log('clear scorecard')
  }

  const handleResetBackConfirm = () => {
    navigate(-1)
    return setShowConfirmation(false)
  }
  const handleResetBackCancel = () => {
    formikRef.current?.handleSubmit() // This should call the onSubmit
    return setShowConfirmation(false)
  }

  const resetFixtureScorecard = () => {
    const data = {}
    data.fixtureId = props.fixtureId
    data.inning = props.defaultInning
    ScorecardService.clearFixtureScorecard(data).then((res) => {
      if (res.status === 200) {
        setCommonScorecardLoading(false)
        props.fetchData()
        ToastComponent(res.message, 'success')
      }
    })
  }

  const handleOutsideButtonClick = () => {
    if (formRef.current) {
      formRef.current.dispatchEvent(new Event('submit')) // Trigger form submission
    }
  }

  const dropdownCol1 = [
    { key: 'rs' },
    { key: 'bf' },
    { key: 'fours' },
    { key: 'sixes' },
    { key: 'overs' },
    { key: 'mdns' },
    { key: 'run' },
    { key: 'wks' },
    { key: 'cs' },
    { key: 'cwks' },
    { key: 'sts' },
    { key: 'rods' },
    { key: 'roas' },
  ]
  const dropdownCol2 = [{ key: 'dks' }, { key: 'hattrick' }, { key: 'no' }]
  const dropdownCol3 = [{ key: 'hwot' }]
  const dropdownCol4 = [
    { key: 'wb' },
    { key: 'wct' },
    { key: 'wcwk' },
    { key: 'wlbw' },
    { key: 'wst' },
    { key: 'whw' },
    { key: 'dotp' },
    { key: 'dotb' },
  ]
  const param = useParams()
  const [completeMarkModalData, setCompleteMarkModalData] = useState([])
  const handleMatchStatus = (e) => {
    setStatusValue(e.target.value)
    const data = {}
    data.fixtureId = param.fixtureId
    data.status = e.target.value
    data.inning = defaultInning
    if (e.target.value === '2') {
      ScorecardService.getSavedScorecardData(data).then((res) => {
        if (res.status === 200) {
          setCompleteMarkModalData(res.data)
          setCompletMarkModalVisible(true)
        }
      })
    } else {
      formikRef.current?.handleSubmit() // This should call the onSubmit
      ScorecardService.changFixtureStatus(param.fixtureId, e.target.value)
        .then((res) => {
          if (res.status === 200) {
            ToastComponent(res.message, 'success')
            navigate(`/scorecard/${param.fixtureId}/${param.teamId}`)
          } else {
            ToastComponent(res.message, 'error')
          }
        })
        .catch((e) => {
          console.log('e', e)
          ToastComponent('Something went wrong.', 'error')
        })
    }
  }
  const changeInning = (e) => {
    setDefaultInning(e.target.value)
    props.fetchData(e.target.value)
  }

  // Detect changes in form values
  const [isFormModified, setIsFormModified] = useState(false)
  const [showConfirmation, setShowConfirmation] = useState(false)
  useEffect(() => {
    const handleFormChange = () => {
      const isModified = Object.keys(formik.initialValues).some(
        (key) => formik.values[key] !== formik.initialValues[key],
      )
      setIsFormModified(isModified)
    }

    // Trigger form change detection whenever formik values change
    handleFormChange()
  }, [formik]) // This will run on every form value change

  // Prevent navigation if form is modified
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isFormModified) {
        const message = 'You have unsaved changes, are you sure you want to leave?'
        e.returnValue = message // Standard for most browsers
        return message // For some browsers
      }
    }

    // Listen to the beforeunload event
    window.addEventListener('beforeunload', handleBeforeUnload)

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [isFormModified]) // Only run when form is modified

  // Handle browser back/forward navigation
  useEffect(() => {
    const handlePopState = (e) => {
      if (isFormModified) {
        // Show the confirmation dialog
        setShowConfirmation(true)

        // Prevent back navigation until the user confirms
        e.preventDefault()
      }
    }

    // Add event listener for popstate (for back/forward buttons)
    window.addEventListener('popstate', handlePopState)

    // Cleanup on unmount
    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [isFormModified]) // Only re-run when form is modified

  // Handle the confirmation dialog result
  const handleConfirmationResult = (result) => {
    if (result) {
      // Allow the navigation
      setShowConfirmation(false)
      navigate(-1)
    } else {
      // Stay on the page
      setShowConfirmation(false)
    }
  }
  return commonScorecardLoading ? (
    <Loader />
  ) : (
    <>
      <CForm className="row g-3" onSubmit={formik.handleSubmit}>
        <CRow>
          <CCol xs={12} md={3} className="pt-3 pb-2">
            <span>
              <b> Round</b>: {props.fixtureDetails.round}
            </span>
          </CCol>
          <CCol xs={12} md={3} className="pt-3 pb-2">
            <span>
              <b> Team</b>: {props.fixtureDetails.team_name}
            </span>
          </CCol>
          <CCol xs={12} md={3} className="pt-3 pb-2">
            <span>
              <b> Start Date/Time</b>: {moment(props.fixtureDetails.start_date).format('D.MM.YYYY')}
              {', '}
              {moment(props.fixtureDetails.start_time, ['HH:mm']).format('h:mma')}
            </span>
          </CCol>
          <CCol xs={12} md={3} className="pt-3 pb-2">
            <span>
              <b> End Date/Time</b>: {moment(props.fixtureDetails.end_date).format('D.MM.YYYY')}
              {', '}
              {moment(props.fixtureDetails.end_time, ['HH:mm']).format('h:mma')}
            </span>
          </CCol>

          {props.fixtureDetails?.match_type_name === '2-Day' && (
            <CCol xs={12} md={3} className="pt-3 pb-2">
              <CFormLabel className="fw-bold" htmlFor="Country">
                Inning
              </CFormLabel>
              <CFormSelect
                aria-label="select inning"
                name="inning"
                onChange={changeInning}
                className={
                  'form-control' +
                  (formik.errors.inning && formik.touched.inning ? ' is-invalid' : '')
                }
                value={defaultInning}
                id="inning"
              >
                <option value={1}>1st Innings</option>
                <option value={2}>2nd Innings</option>
              </CFormSelect>
            </CCol>
          )}

          {props.isMobile ? (
            <CCol xs={12}>
              <CCard className="mb-4">
                <CCardHeader>
                  <strong>
                    <strong>
                      {props.fixtureDetails.scorcard_link_url ? (
                        <Link to={props.fixtureDetails.scorcard_link_url} target="_blank">
                          Scorecard
                        </Link>
                      ) : (
                        'Scorecard'
                      )}
                    </strong>
                  </strong>
                  <CHeaderNav className="float-end">
                    <CButtonGroup aria-label="Theme switch">
                      <CButton color={'primary'} onClick={handleOutsideButtonClick} title="Save">
                        <CIcon icon={cilSave} />
                      </CButton>
                      <CButton
                        color={'danger'}
                        onClick={() => {
                          clearScorecard()
                        }}
                        title="Reset"
                      >
                        <CIcon icon={cilReload} />
                      </CButton>
                      <CButton
                        color={'success'}
                        href={`/manage-scores/team-players/${props.fixtureId}/${props.teamId}`}
                        title="Squad"
                      >
                        <CIcon icon={cilList} />
                      </CButton>
                      <CButton color={'warning'} onClick={props.handleInfoClick} title="Legend">
                        <CIcon icon={cilInfo} />
                      </CButton>
                    </CButtonGroup>
                  </CHeaderNav>
                </CCardHeader>
                <CCardBody>
                  {props.loader ? (
                    <Loader />
                  ) : (
                    <CAccordion alwaysOpen>
                      {props.scorecardDetails &&
                        props.scorecardDetails.map((item, key1) => (
                          <CAccordionItem itemKey={key1} key={item?.id}>
                            <CAccordionHeader>{item.player_name}</CAccordionHeader>
                            <CAccordionBody>
                              <CRow className="mb-2">
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Fantasy Points
                                    </CInputGroupText>
                                    <CFormInput
                                      defaultValue={props.formatFantasyPoints(item.fantasy_points)}
                                      id="fantasy_points"
                                      disabled={true}
                                    />
                                  </CInputGroup>
                                </div>
                                {props.scorecardColoumns
                                  .filter((value) =>
                                    dropdownCol1.some(
                                      (dropdown) => dropdown.key === value?.attribute_key,
                                    ),
                                  )
                                  .map((value, key) => (
                                    <>
                                      <div className="col-md-2 col-sm">
                                        <CInputGroup className="mb-2">
                                          <CInputGroupText
                                            id="inputGroup-sizing-default"
                                            style={{ width: '135px' }}
                                          >
                                            {value?.label}
                                          </CInputGroupText>
                                          <CFormInput
                                            name={`data[${key1}]${value?.attribute_key}`}
                                            defaultValue={item[value?.attribute_key]}
                                            type={'number'}
                                            onChange={formik.handleChange}
                                            className="col-sm-10"
                                            id="rs"
                                          />
                                        </CInputGroup>
                                      </div>
                                    </>
                                  ))}
                                {props.scorecardColoumns
                                  .filter((value) =>
                                    dropdownCol2.some(
                                      (dropdown) => dropdown.key === value?.attribute_key,
                                    ),
                                  )
                                  .map((value, key) => (
                                    <>
                                      <div className="col-md-2 col-sm">
                                        <CInputGroup className="mb-2">
                                          <CInputGroupText
                                            id="inputGroup-sizing-default"
                                            style={{ width: '135px' }}
                                          >
                                            {value?.label}
                                          </CInputGroupText>
                                          <CFormSelect
                                            id="dks"
                                            values={item[value?.attribute_key]}
                                            name={`data[${key1}]${value?.attribute_key}`}
                                            defaultValue={item[value?.attribute_key]}
                                            onChange={formik.handleChange}
                                          >
                                            <option value={0}>No</option>
                                            <option value={1}>Yes</option>
                                          </CFormSelect>
                                        </CInputGroup>
                                      </div>
                                    </>
                                  ))}

                                {props.scorecardColoumns
                                  .filter((value) =>
                                    dropdownCol3.some(
                                      (dropdown) => dropdown.key === value?.attribute_key,
                                    ),
                                  )
                                  .map((value, key) => (
                                    <>
                                      <div className="col-md-2 col-sm">
                                        <CInputGroup className="mb-2">
                                          <CInputGroupText
                                            id="inputGroup-sizing-default"
                                            style={{ width: '135px' }}
                                          >
                                            {value?.label}
                                          </CInputGroupText>
                                          <CFormSelect
                                            onChange={formik.handleChange}
                                            id={value?.attribute_key}
                                            values={item[value?.attribute_key]}
                                            name={`data[${key1}]${value?.attribute_key}`}
                                            defaultValue={item[value?.attribute_key]}
                                          >
                                            <option value={''}>Select Dismissal</option>
                                            <option value={'hobwl'}>Bowled</option>
                                            <option value={'hoct'}>Catch</option>
                                            <option value={'hocwk'}>Catch WK</option>
                                            <option value={'holbw'}>LBW</option>
                                            <option value={'host'}>Stump</option>
                                            <option value={'horod'}>RO-Direct</option>
                                            <option value={'horoa'}>RO-Assist</option>
                                            <option value={'hohw'}>Hit Wicket</option>
                                            <option value={'hohb'}>Handled-Ball</option>
                                            <option value={'hoobs'}>Obstruct</option>
                                            <option value={'hotmd'}>Timed</option>
                                          </CFormSelect>
                                        </CInputGroup>
                                      </div>
                                    </>
                                  ))}

                                {props.scorecardColoumns
                                  .filter((value) =>
                                    dropdownCol4.some(
                                      (dropdown) => dropdown.key === value?.attribute_key,
                                    ),
                                  )
                                  .map((value, key) => (
                                    <>
                                      <div className="col-md-2 col-sm">
                                        <CInputGroup className="mb-2">
                                          <CInputGroupText
                                            id="inputGroup-sizing-default"
                                            style={{ width: '135px' }}
                                          >
                                            {value?.label}
                                          </CInputGroupText>
                                          <CFormInput
                                            name={`data[${key1}]${value?.attribute_key}`}
                                            type={'number'}
                                            defaultValue={item[value?.attribute_key]}
                                            id={value?.attribute_key}
                                            onChange={formik.handleChange}
                                          />
                                        </CInputGroup>
                                      </div>
                                    </>
                                  ))}
                              </CRow>
                            </CAccordionBody>
                          </CAccordionItem>
                        ))}
                    </CAccordion>
                  )}
                </CCardBody>
              </CCard>
            </CCol>
          ) : (
            <CCol xs={12}>
              <CCard className="mb-4">
                <CCardHeader>
                  <strong>
                    {props.fixtureDetails.scorcard_link_url ? (
                      <Link to={props.fixtureDetails.scorcard_link_url} target="_blank">
                        Scorecard
                      </Link>
                    ) : (
                      'Scorecard'
                    )}
                  </strong>
                  <CHeaderNav className="float-end">
                    <CButtonGroup aria-label="Theme switch">
                      <CButton color={'primary'} onClick={handleOutsideButtonClick} title="Save">
                        <CIcon icon={cilSave} />
                      </CButton>

                      <CButton
                        color={'success'}
                        href={`/manage-scores/team-players/${props.fixtureId}/${props.teamId}`}
                        title="Squad"
                      >
                        <CIcon icon={cilList} />
                      </CButton>
                      <CButton color={'warning'} onClick={props.handleInfoClick} title="Legend">
                        <CIcon icon={cilInfo} />
                      </CButton>
                    </CButtonGroup>
                  </CHeaderNav>
                </CCardHeader>
                <CCardBody>
                  {props.loader ? (
                    <Loader />
                  ) : (
                    <div className="table-responsive" style={{ overflowX: 'auto' }}>
                      <table
                        className="main-table table innertable"
                        style={{ borderCollapse: 'collapse', width: '100%' }}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                position: 'sticky',
                                left: 0,
                                zIndex: 2,
                                backgroundColor: '#fff',
                                width: '150px', // Adjust width as needed
                              }}
                            >
                              PLAYER
                            </th>
                            <th>
                              <CTooltip content="Position">
                                <CLink> POS </CLink>
                              </CTooltip>
                            </th>
                            <th>
                              <CTooltip content="Fantasy Points">
                                <CLink> FP </CLink>
                              </CTooltip>
                            </th>
                            {props.scorecardColoumns.map((value, key) => (
                              <>
                                <th key={key}>
                                  <CTooltip content={value?.full_name}>
                                    <CLink> {value?.label} </CLink>
                                  </CTooltip>
                                </th>
                              </>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {props.scorecardDetails &&
                            props.scorecardDetails.map((item, key1) => (
                              <tr key={key1}>
                                <td
                                  style={{
                                    position: 'sticky',
                                    left: 0,
                                    zIndex: 1,
                                    backgroundColor: '#f9f9f9',
                                    width: '35px',
                                  }}
                                >
                                  {item.player_name}
                                </td>
                                <td>
                                  {item?.player_position == 1 ? 'BAT' : ''}
                                  {item?.player_position == 2 ? 'BOWL' : ''}
                                  {item?.player_position == 3 ? 'AR' : ' '}
                                  {item?.player_position == 4 ? 'WK' : ''}
                                </td>
                                <td>
                                  <CFormInput
                                    defaultValue={props.formatFantasyPoints(item.fantasy_points)}
                                    id="fantasy_points"
                                    disabled={true}
                                    style={{ minWidth: '70px' }}
                                  />
                                </td>
                                {props.scorecardColoumns
                                  .filter((value) =>
                                    dropdownCol1.some(
                                      (dropdown) => dropdown.key === value?.attribute_key,
                                    ),
                                  )
                                  .map((value, key) => (
                                    <>
                                      <td>
                                        <CFormInput
                                          name={`data[${key1}]${value?.attribute_key}`}
                                          type={'number'}
                                          defaultValue={item[value?.attribute_key]}
                                          onChange={formik.handleChange}
                                          id={value?.attribute_key}
                                          style={{ minWidth: '70px' }}
                                        />
                                      </td>
                                    </>
                                  ))}
                                {props.scorecardColoumns
                                  .filter((value) =>
                                    dropdownCol2.some(
                                      (dropdown) => dropdown.key === value?.attribute_key,
                                    ),
                                  )
                                  .map((value, key) => (
                                    <>
                                      <td>
                                        <CFormSelect
                                          id={value?.attribute_key}
                                          values={item[value?.attribute_key]}
                                          name={`data[${key1}]${value?.attribute_key}`}
                                          defaultValue={item[value?.attribute_key]}
                                          onChange={formik.handleChange}
                                          style={{ minWidth: '70px' }}
                                        >
                                          <option value={0}>No</option>
                                          <option value={1}>Yes</option>
                                        </CFormSelect>
                                      </td>
                                    </>
                                  ))}
                                {props.scorecardColoumns
                                  .filter((value) =>
                                    dropdownCol3.some(
                                      (dropdown) => dropdown.key === value?.attribute_key,
                                    ),
                                  )
                                  .map((value, key) => (
                                    <>
                                      <td>
                                        <CFormSelect
                                          id={value?.attribute_key}
                                          values={item[value?.attribute_key]}
                                          name={`data[${key1}]${value?.attribute_key}`}
                                          defaultValue={item[value?.attribute_key]}
                                          onChange={formik.handleChange}
                                          style={{ minWidth: '70px' }}
                                        >
                                          <option value={''}>Select Dismissal</option>
                                          <option value={'hobwl'}>Bowled</option>
                                          <option value={'hoct'}>Catch</option>
                                          <option value={'hocwk'}>Catch WK</option>
                                          <option value={'holbw'}>LBW</option>
                                          <option value={'host'}>Stump</option>
                                          <option value={'horod'}>RO-Direct</option>
                                          <option value={'horoa'}>RO-Assist</option>
                                          <option value={'hohw'}>Hit Wicket</option>
                                          <option value={'hohb'}>Handled-Ball</option>
                                          <option value={'hohb'}>Handled-Ball</option>
                                          <option value={'hoobs'}>Obstruct</option>
                                          <option value={'hotmd'}>Timed</option>
                                        </CFormSelect>
                                      </td>
                                    </>
                                  ))}
                                {props.scorecardColoumns
                                  .filter((value) =>
                                    dropdownCol4.some(
                                      (dropdown) => dropdown.key === value?.attribute_key,
                                    ),
                                  )
                                  .map((value, key) => (
                                    <>
                                      <td>
                                        <CFormInput
                                          name={`data[${key1}]${value?.attribute_key}`}
                                          type={'number'}
                                          defaultValue={item[value?.attribute_key]}
                                          onChange={formik.handleChange}
                                          id={value?.attribute_key}
                                          style={{ minWidth: '70px' }}
                                        />
                                      </td>
                                    </>
                                  ))}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </CCardBody>
              </CCard>
            </CCol>
          )}
          <CCol xs={12}>
            <CCard className="mb-4">
              <CCardHeader>
                <strong>Scorecard Details</strong>
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CCol md={6}>
                    <CFormLabel htmlFor="phone">Scorecard Source</CFormLabel>
                    <input
                      type="text"
                      name="scorcard_link_name"
                      className={'form-control'}
                      id="scorcard_link_name"
                      placeholder="Scorecard Source"
                      defaultValue={formik.values.scorcard_link_name}
                      onChange={(e) => props.handleInputChange(e, 'scorcard_link_name')}
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormLabel htmlFor="phone">Scorecard Link</CFormLabel>
                    <input
                      type="text"
                      name="scorcard_link_url"
                      className={'form-control'}
                      id="scorcard_link_url"
                      placeholder="Scorecard Link"
                      defaultValue={formik.values.scorcard_link_url}
                      onChange={(e) => props.handleInputChange(e, 'scorcard_link_url')}
                    />
                  </CCol>

                  <CCol md={6}>
                    <CFormLabel htmlFor="fall_of_wickets" className="mt-3">
                      Fall of Wickets
                    </CFormLabel>
                    <CFormTextarea
                      aria-label="With textarea"
                      defaultValue={formik.values.fall_of_wickets}
                      name={'fall_of_wickets'}
                      onChange={(e) => props.handleInputChange(e, 'fall_of_wickets')}
                    ></CFormTextarea>
                  </CCol>
                  {/* <CCol md={6}>
              <CFormLabel htmlFor="Add Match Report" className="mt-3">
                Add Match Report
              </CFormLabel>
              <CFormTextarea
                aria-label="With textarea"
                defaultValue={formik.values.match_report}
                name={'match_report'}
                onChange={formik.handleChange}
              ></CFormTextarea>
            </CCol> */}
                  {/* <CCol md={6} className="mb-4">
              <CFormLabel htmlFor="formFile" className="mt-3">
                Upload Match Scorecard
              </CFormLabel>
              <CFormInput type="file" id="upload_video" />
            </CCol> */}
                </CRow>
              </CCardBody>
            </CCard>

            {/* <MarkAsCompleteModal
        completMarkModalVisible={completMarkModalVisible}
        setCompletMarkModalVisible={setCompletMarkModalVisible}
        data={completeMarkModalData}
      /> */}
          </CCol>
          <CCol xs={12}>
            <CCard className="mb-6">
              <CCardHeader>
                <strong>Bonus Points</strong>
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CCol md={6}>
                    <CFormLabel htmlFor="player_of_the_match">Player Of The Match</CFormLabel>

                    <CMultiSelect
                      id="player_of_the_match"
                      options={props.playerList}
                      selectionType="tags"
                      name="player"
                      onChange={props.handleChange}
                      value={props.playerList.filter((obj) =>
                        props.selectedValue.includes(obj.value),
                      )}
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormLabel htmlFor="Match Result">Match Result</CFormLabel>
                    <CFormSelect
                      id="potm_match_status"
                      value={formik.values.potm_match_status}
                      onChange={formik.handleChange}
                    >
                      <option>Select Match Result</option>
                      <option value="1">Won</option>
                      <option value="2">Other</option>
                    </CFormSelect>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
            {/* <MarkAsCompleteModalp
        completMarkModalVisible={completMarkModalVisible}
        setCompletMarkModalVisible={setCompletMarkModalVisible}
        data={completeMarkModalData}
      /> */}
          </CCol>

          <CCol xs={12}>
            <CCard className="mb-4">
              <CCardHeader>
                <strong>Save Scores</strong>
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CCol md={6}>
                    <CLoadingButton
                      type="submit"
                      color="success"
                      variant="outline"
                      loading={props.loader}
                      className="mt-3"
                    >
                      Press to Save
                    </CLoadingButton>
                    {/* <CLoadingButton
                      type="button"
                      color="danger"
                      variant="outline"
                      onClick={() => {
                        clearScorecard()
                      }}
                      className="mt-3 ml-2"
                    >
                      Reset
                    </CLoadingButton> */}
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>

          <CCol xs={12}>
            <CCard className="mb-4 mt-3">
              <CCardHeader>
                <strong>Match Status</strong>
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CCol md={6}>
                    <CFormLabel htmlFor="Add Match Report" className="mr-1 mt-3">
                      Match Status
                    </CFormLabel>
                    <CButton
                      color="danger"
                      size="sm"
                      onClick={() => props.setVisible(!props.visible)}
                    >
                      <CIcon icon={cilInfo} className="" fontSize={12} />
                    </CButton>
                    <CFormSelect
                      aria-label="Select Structure"
                      name="match_status"
                      className={
                        'mt-3 form-control' +
                        (formik.errors.match_status && formik.touched.match_status
                          ? ' is-invalid'
                          : '')
                      }
                      value={props.statusValue}
                      id="match_status"
                      // onChange={props.handleMatchStatus}
                      onChange={(e) => {
                        formik.handleChange(e)
                        handleMatchStatus(e)
                      }}
                    >
                      <option value={0}>Select Match Status </option>
                      <option value={1}>In-Progress</option>
                      <option value={2}>Completed</option>
                    </CFormSelect>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CForm>
      <Bootbox
        show={showResetConfirm}
        type={'confirm'}
        message={'Are you sure you want to reset this?'}
        onSuccess={handleResetConfirm}
        onCancel={handleResetCancel}
        onClose={handleResetCancel}
      />
      {/* <Bootbox
        show={showResetBackConfirm}
        type={'confirm'}
        message={
          'You are exiting without saving unsaved data. Are you sure you want to discard the changes?'
        }
        onSuccess={handleResetBackConfirm}
        onCancel={handleResetBackCancel}
        onClose={handleResetBackCancel}
      /> */}
      <CompleteMarkModal visible={visible} setVisible={setVisible} />
      <MarkAsCompleteModal
        completMarkModalVisible={completMarkModalVisible}
        setCompletMarkModalVisible={setCompletMarkModalVisible}
        data={completeMarkModalData}
        fixtureId={param.fixtureId}
        finalScorecardModalVisible={finalScorecardModalVisible}
        setFinalScorecardModalVisible={setFinalScorecardModalVisible}
      />
      <Bootbox
        show={showConfirmation}
        type={'confirm'}
        message={
          'You are exiting without saving unsaved data. Are you sure you want to discard the changes?'
        }
        onSuccess={handleResetBackConfirm}
        onCancel={handleResetBackCancel}
        onClose={handleResetBackCancel}
        buttons={{
          confirm: {
            label: 'Save & Exit', // Customize the button label here
            className: 'btn-primary', // Optionally, change the button class for styling
          },
          cancel: {
            label: 'Discard & Exit', // Customizing 'Cancel' button
            className: 'btn-danger', // Optional: Add custom class for styling
          },
        }}
      />
    </>
  )
}

export default CommonScorecard
